import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getOrderExpiry, getOrderRelatedShowtimesByIds, getOrderShowtimes } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { Countdown } from '../../subcomponents/countdown/countdown';
import { Icon } from '../../subcomponents/icon';
import { withComponentWrapper } from '../../utils/with-component-wrapper';
import { defaultOrderExpiryCountdownProps, orderExpiryCountdownPropsValidator } from './types/props';
const b = bemClassBuilder('v-order-expiry-countdown');
const OrderExpiryCountdown = observer(props => {
    const { displayText, events, assets } = props;
    const { countdownIconName } = assets;
    const orderExpiry = getOrderExpiry();
    if (!orderExpiry)
        return null;
    const handleCountdownExpired = () => {
        const showtimes = getOrderRelatedShowtimesByIds(getOrderShowtimes().map(showtime => showtime.showtimeId));
        if (events.onOrderExpired)
            events.onOrderExpired(showtimes);
    };
    const labelFormat = { text: displayText.countdownLabelFormat, className: b.element('text') };
    return (_jsx("div", Object.assign({ className: b.block() }, { children: _jsxs("div", Object.assign({ className: b.element('wrapper') }, { children: [_jsx(Icon, { name: countdownIconName, className: b.element('icon'), size: 24 }), _jsx(Countdown, { targetDate: orderExpiry, labelFormat: labelFormat, onExpire: handleCountdownExpired })] })) })));
});
OrderExpiryCountdown.displayName = 'OrderExpiryCountdown';
/**
 * The **Order Expiry Countdown** component displays a countdown until the current in-progress order expires.
 */
export const OrderExpiryCountdownComponent = withComponentWrapper(OrderExpiryCountdown, defaultOrderExpiryCountdownProps, orderExpiryCountdownPropsValidator);
